const selectors = {
    open: '[data-action="open-side-cart"]',
    indicators: '.site-header__cart-indicator'
};
export { selectors };
